/** @format */

import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NewUser, UpdateUserAccount, User } from 'src/app/store/application';

@Injectable()
export class UserService {
	userUrl = 'api/users';

	httpOptions = {
		headers: new HttpHeaders({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	};

	constructor(private httpClient: HttpClient) {}

	addSingleUser(newUser: NewUser): Observable<string> {
		return this.httpClient.post<string>(`${this.userUrl}`, newUser, this.httpOptions);
	}

	activateCurrentUser(): Observable<any> {
		return this.httpClient.post(`${this.userUrl}/activateCurrentUser`, this.httpOptions);
	}

	getUsers(): Observable<User[]> {
		return this.httpClient.get<User[]>(this.userUrl, this.httpOptions);
	}

	getManagedUsers(): Observable<User[]> {
		return this.httpClient.get<User[]>(`${this.userUrl}/managedUsers`, this.httpOptions);
	}

	createNewUser(newUser: User): Observable<any> {
		return this.httpClient.post(`${this.userUrl}/admin/newUser`, newUser, this.httpOptions);
	}

	updateExistingUser(updatedUserDetails: UpdateUserAccount): Observable<any> {
		return this.httpClient.post(`${this.userUrl}/admin/updateExistingUser`, updatedUserDetails, this.httpOptions);
	}

	getADFilteredUserEmployeeId(upn: string): Promise<any> {
		return this.httpClient.get(`${this.userUrl}/admin/user/${upn}`, this.httpOptions).toPromise();
	}

	getADFilteredUserManager(upn: string): Promise<any> {
		return this.httpClient.get(`${this.userUrl}/admin/user/${upn}/manager`, this.httpOptions).toPromise();
	}

	getTimesheetGroupMembers(): Promise<any> {
		return this.httpClient.get(`${this.userUrl}/admin/ADGroup/members`, this.httpOptions).toPromise();
	}
}
